<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-10-10 10:43:13
 * @Description: 
--> 
<template>
  <Drawer
    width="400"
    title="新增客户"
    v-model="drawerOpened"
    style="padding: 0"
  >
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        @submit.native.prevent
        label-position="top"
      >
        <FormItem label="公司名" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="简称" prop="abbr">
          <Input v-model="formItem.abbr" placeholder="输入简称..." />
        </FormItem>
        <FormItem label="可见部门" prop="department">
          <Tree
            :data="treeDepartmentData"
            ref="createDepartTree"
            show-checkbox
            multiple: false
            @on-check-change="selectDepartment"
          ></Tree>
          <Alert
            v-if="getDepartmentByType('sales').length === 0"
            type="warning"
            style="margin-top: 8px"
            >注意：该公司暂时还没有创建销售部门，请前往“用户和权限”菜单新建部门，只有勾选了“销售”的部门才会这里出现</Alert
          >
        </FormItem>
        <FormItem label="可见人" prop="user">
          <Select v-model="formItem.user" multiple>
            <Option
              v-for="item in userList.filter((x) => !x.superAdmin)"
              :value="item._id"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="纳入销售统计">
          <i-switch v-model="formItem.includeInStat.SO" size="large">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "AddNewCustomerDrawer",
  data() {
    return {
      drawerOpened: false,
      formItem: {
        name: "",
        abbr: "",
        department: [],
        includeInStat: {
          SO: true,
        },
        user: undefined,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "change" }],
      },
    };
  },
  methods: {
    ...mapActions({
      createCustomer: "customer/createCustomerAction",
      getDepartmentList: "department/getDepartmentListAction",
      getUserList: "user/getUsersAction",
    }),
    selectDepartment(value) {
      this.formItem.department = [];
      for (let i = 0; i < value.length; i++) {
        if (value[i]._id) this.formItem.department.push(value[i]._id);
      }
    },
    openDrawer(customerId) {
      this.handleReset("formItem");
      this.drawerOpened = true;
      this.getDepartmentList({});
      this.getUserList({});
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            let data;
            if (this.formItem.department.length > 0) {
              data = {
                ...this.formItem,
                department: this.formItem.department,
              };
            } else {
              data = {
                name: this.formItem.name,
                abbr: this.formItem.abbr,
                includeInStat: this.formItem.includeInStat,
              };
            }
            await this.createCustomer(data);
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
  computed: {
    ...mapGetters({
      getDepartmentByType: "department/getDepartmentByType",
      getTreeDepartment: "department/getTreeDepartment",
    }),
    ...mapState({
      userList: (state) => state.user.userList,
    }),
    treeDepartmentData: function () {
      let data = this.getTreeDepartment();
      return data;
    },
  },
};
</script>

<style scoped lang="stylus"></style>
